import {
  EVENTS_ERROR,
  EVENTS_REQUEST,
  EVENTS_RESET,
  EVENTS_SUCCESS,
} from "./ActionType";

export const initialState = {
  isRequest: false,
  isSuccess: false,
  isError: false,
  data: null,
  error: null,
  shopId: null,
  requestId: null,
};

const hasRequestMeta = (meta) =>
  typeof meta?.shopId === "string" &&
  meta.shopId.length > 0 &&
  typeof meta?.requestId === "string" &&
  meta.requestId.length > 0;

const isActiveRequest = (state, meta) =>
  hasRequestMeta(meta) &&
  state.shopId === meta.shopId &&
  state.requestId === meta.requestId;

const eventsReducer = (state = initialState, action) => {
  switch (action.type) {
    case EVENTS_REQUEST:
      if (!hasRequestMeta(action.meta)) return state;
      return {
        isRequest: true,
        isSuccess: false,
        isError: false,
        data: null,
        error: null,
        shopId: action.meta.shopId,
        requestId: action.meta.requestId,
      };
    case EVENTS_SUCCESS:
      if (!isActiveRequest(state, action.meta)) return state;
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        data: action.payload,
        error: null,
      };
    case EVENTS_ERROR:
      if (!isActiveRequest(state, action.meta)) return state;
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        data: null,
        error: action.payload,
      };
    case EVENTS_RESET:
      if (
        action.meta?.shopId !== undefined &&
        state.shopId !== String(action.meta.shopId)
      ) {
        return state;
      }
      return initialState;
    default:
      return state;
  }
};

export default eventsReducer;
